// OverallAccountPdf.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const generateOverallAccountPDF = (data = []) => {
  // eslint-disable-next-line
  const doc = new jsPDF();

  doc.setFontSize(16);
const title = 'Overall Restaurant Account Report';
const pageWidth = doc.internal.pageSize.getWidth();
const textWidth = doc.getTextWidth(title);
const x = (pageWidth - textWidth) / 2;
doc.text(title, x, 20);

  const tableColumn = ['Sr. No.', 'Restaurant Name', 'Balance'];
  const tableRows = [];

  data.forEach((item, index) => {
    const rowData = [
      index + 1,
      item.restaurant_name,
      `${parseFloat(item.balance || 0).toLocaleString()} ${item.balance_label || ''}`,
    ];
    tableRows.push(rowData);
  });

  autoTable(doc, {
    startY: 30,
    head: [tableColumn],
    body: tableRows,
    theme: 'grid',
    headStyles: { fillColor: [22, 160, 133] },
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
  });

  doc.save('overall_res_account_report.pdf');
};


export default generateOverallAccountPDF;
